import { API_BETA, jsonHeadersWithToken, parseJsonSafe, getErrorMessage } from '@/lib/constants'

const BASE_URL = API_BETA

const handleApiResponse = async (response, errorMessage) => {
  if (!response.ok) {
    const errorData = await parseJsonSafe(response)
    throw new Error(getErrorMessage(errorData, errorMessage))
  }
  const result = await parseJsonSafe(response)
  return result.data || result
}

export const checkSubdomainAvailability = async (subdomain, userId) => {
  const url = `${BASE_URL}domains/${userId}/check-subdomain?subdomain=${encodeURIComponent(subdomain)}`
  const response = await fetch(url, { method: 'GET', headers: jsonHeadersWithToken() })
  return handleApiResponse(response, 'Failed to check subdomain availability')
}

// Upsert a marked managed-head snippet (chatbot / cookie-banner / calendar embed) into a
// visual-builder project's <head>. Wrapped server-side in <!-- cd:head:<key> --> markers so it
// never touches the user's own head code. Call the publish flow afterwards to push it live.
export const setProjectHeadSnippet = async (project, key, snippet, enabled = true) => {
  const url = `${BASE_URL}guest/web-builder/head-snippet`
  const response = await fetch(url, {
    method: 'POST',
    headers: jsonHeadersWithToken(),
    body: JSON.stringify({ project, key, snippet, enabled }),
  })
  return handleApiResponse(response, 'Failed to update site head snippet')
}

export const addSubdomainToProject = async (project, subdomain, options = {}) => {
  const params = new URLSearchParams({ project, subdomain })
  if (options.publishAfterAdd) params.append('publishAfterAdd', 'true')
  
  const url = `${BASE_URL}guest/web-builder/add-subdomain?${params.toString()}`
  const response = await fetch(url, {
    method: 'POST',
    headers: jsonHeadersWithToken(),
    body: JSON.stringify({ activeStatus: options.activeStatus || { subdomain: true } }),
  })
  return handleApiResponse(response, 'Failed to add subdomain')
}

export const publishPage = async (context, project, options = {}) => {
  const params = new URLSearchParams({ context: context || 'home', project })
  if (options.domain) params.append('domain', 'true')
  if (options.subdomain) params.append('subdomain', 'true')
  if (options.customSubdomain) params.append('customSubdomain', options.customSubdomain)
  
  const url = `${BASE_URL}guest/web-builder/publish?${params.toString()}`
  const response = await fetch(url, { method: 'GET', headers: jsonHeadersWithToken() })
  return handleApiResponse(response, 'Failed to publish page')
}

export const exportCode = async (context, project, extras) => {
  const url = `${BASE_URL}guest/web-builder/export`

  const extrasPayload = {
    height: window.screen.height || 1080,
    width: window.screen.width || 1920,
    heightOffset: 0.0029,
    ...extras,
    ...(extras.props && { props: extras.props }),
  }
  
  const payload = {
    context: context || 'home',
    project,
    extras: extrasPayload,
    source: 'exportPopup',
  }

  const response = await fetch(url, {
    method: 'POST',
    headers: jsonHeadersWithToken(),
    body: JSON.stringify(payload),
  })

  if (!response.ok) {
    const errorData = await parseJsonSafe(response)
    throw new Error(getErrorMessage(errorData, 'Failed to export code'))
  }

  return response.blob()
}


